import request from '@index/utils/request'

export function handleQueryUserPublicMatchAuth(data) { //获取用户是否具有发布赛事权限
  return request({
    url: 'applypublicmatchauth/queryUserPublicMatchAuth',
    method: 'post',
    data
  })
}
